<div style="padding: 20px">
    <br>
    <p>
        <label class="SmallHeadings">Summary of Important Rules:<br><br /></label>
        <label class="MainText"> 
            See here for detailed rules - <a href="http://www.racketlon.com/rackrules.html">www.racketlon.com - Rules</a><br><br>

            -Whoever serves first in the first sport serves 2nd in 2nd & 4th sports, 1st receiver chooses end.<br>
            -2 serves each, Every Rally counts regardless of server.<br>
            -All matches are to 21, 2 serves each, must win by 2.<br>
            -Winner is the person with the most points (not sets), i.e 21-19, 21-19, 21-19, 2-21 = Player B wins 65-78.<br>
            -In a Knockout event when it becomes impossible for 1 player to win then either player can choose to end the match.<br>
            -If scores are tied after 4 sports then 1 extra tiebreak point is played in the last sport, server is decided by toss, if Tennis then no second serve allowed.<br>
            -Squash doubles will be played as singles, bottom 2 squash players play till one reaches 11 then the top 2 takeover.<br>
            <br></label>
    </p>

    <p>
        <label class="SmallHeadings">Rankings Info<br><br /></label>
        <label class="MainText"> 
            Players are excluded from the rankings if not based in NZ or have been inactive for a two year period. However, these players are included in the full RNZ Tour rankings list (until inactive for a five year period).<br><br>

            Only RNZ approved matches/tournaments qualify for the ranking document. RNZ approves and regulates the scoring and conditions of these tournaments.<br><br>

            Rankings points are not weighted differently depending on the level of tournament.<br />
        </label>
    </p>
</div>